export const UserRole = {
  Admin: 0,
  Editor: 1
}

export const defaultLocale = 'en'

export const adminRoot = '/app'

export const themeColorStorageKey = '__theme_selected_color'

export const defaultColor = 'light.bluenavy'

export const defaultDirection = 'ltr'

export const themeRadiusStorageKey = '__theme_radius'

export const isAuthGuardActive = false
